import React from 'react'
import './sub-subtask-2023.css'
import { CheckIcon } from '@heroicons/react/20/solid'

const SubSubtask2023 = ({subtask, sub2x, setOpenModal2023, imEditingATemplate}) => {
    const [hoveringOverCheckbox, setHoveringOverCheckbox] = React.useState(false)

    const changeName = (val) => {
        setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskSubtasks: sub.subtaskSubtasks.map((subsub) => subsub.subtask2xId === sub2x.subtask2xId ? {...subsub, subtask2xName: val} : subsub)} : sub)}))
    }

    const toggleCheckbox = () => {
        imEditingATemplate ? setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskSubtasks: sub.subtaskSubtasks.filter((subsub) => subsub.subtask2xId !== sub2x.subtask2xId && subsub)} : sub)}))
        : setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskSubtasks: sub.subtaskSubtasks.map((subsub) => subsub.subtask2xId === sub2x.subtask2xId ? {...subsub, subtask2xCompleted: !subsub.subtask2xCompleted} : subsub)} : sub)}))
    }

    const checkForAutoClear = (val) => {
        val === "New mini todo..." && setOpenModal2023((prev) => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskSubtasks: sub.subtaskSubtasks.map((subsub) => subsub.subtask2xId === sub2x.subtask2xId ? {...subsub, subtask2xName: ''} : subsub)} : sub)}))
    }

    return(
        <div className='sub-subtask-2023__wrapper'>
            <div className='sub-subtask-2023__checkbox' onClick={toggleCheckbox} onMouseEnter={() => setHoveringOverCheckbox(true)} onMouseLeave={() => setHoveringOverCheckbox(false)} style={(sub2x.subtask2xCompleted || hoveringOverCheckbox) ? {backgroundColor: '#CCFBF1', border: '1px solid #14B8A6'} : {backgroundColor: '#fff'} }>
            {(sub2x.subtask2xCompleted || hoveringOverCheckbox) && <CheckIcon className='subtask-2023__checkmark' color='#14B8A6' />}
            </div>
            <input className='sub-subtask-2023__name' value={sub2x.subtask2xName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => changeName(e.target.value)}  />
        </div>
    )
}
export default SubSubtask2023;